import '../../stylesheets/falcon/workplaceCareer'
import './common'
import './lib/simplebar.js'